module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": _vm.label,
      "required": _vm.required
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "value-key": "value",
      "size": _vm.size
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.formData),
      callback: function($$v) {
        _vm.formData = $$v
      },
      expression: "formData"
    }
  }, _vm._l((_vm.workflows), function(group) {
    return _c('el-option-group', {
      key: group.label,
      attrs: {
        "label": group.label
      }
    }, _vm._l((group.options), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd2adcae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/selects/SelectWorkflow.vue
// module id = 1708
// module chunks = 0